import React, { ReactElement, useMemo } from 'react';
import { AttachmentIcon, ImageViewer, VideoPlayer } from '../../atoms';
import { DialogWindow, DialogWindowHeader } from '..';

import './media-dialog.styles.scss';
import { AttachmentType } from '../../../models';
import { Box } from '@material-ui/core';

export enum MediaType {
	YouTube,
	Image
}

export interface IMediaDialogProps {
	open: boolean;
	type: AttachmentType;
	title: string;
	source?: string;
	onClose: () => void;
}

export function MediaDialog(props: IMediaDialogProps): ReactElement {
	const { open, type, source, title, onClose } = props;

	const mediaType: MediaType = useMemo(() => {
		return getMediaType();
	}, [type]);

	function getMediaType(): MediaType {
		switch (type) {
			case AttachmentType.Video:
				return MediaType.YouTube;
			default:
				return MediaType.Image;
		}
	}

	return (
		<DialogWindow open={open} className="media-dialog">
			<DialogWindowHeader
				title={title}
				icon={
					<AttachmentIcon
						color="#2965fb"
						type={
							mediaType === MediaType.YouTube
								? AttachmentType.Video
								: AttachmentType.Image
						}
					/>
				}
				onClose={onClose}
			/>

			<Box className="media-dialog-content">
				{mediaType === MediaType.YouTube && source && (
					<VideoPlayer videoUrl={source} />
				)}
				{mediaType === MediaType.Image && source && (
					<ImageViewer source={source} alt={title} />
				)}
			</Box>
		</DialogWindow>
	);
}
